import { gql, useQuery } from '@apollo/client';

export const PO_SALE_ORDER_SHIPMENT_LIST_QUERY = gql`
  query PoSaleOrderShipmentList(
    $page: Int!
    $pageSize: Int!
    $poSaleOrderId: Int
    $shipperId: Int
    $shipperIds: [Int!]
    $distributorIds: [Int!]
    $status: String
    $printStatus: String
    $startDate: Date
    $endDate: Date
    $ngayDatHangStartDate: Date
    $ngayDatHangEndDate: Date
    $filter: String
    $heThongMT: [String!]
    $createdStartDate: Date
    $createdEndDate: Date
    $creatorFilter: String
  ) {
    poSaleOrder {
      poSaleOrderShipments(
        page: $page
        pageSize: $pageSize
        poSaleOrderId: $poSaleOrderId
        shipperId: $shipperId
        shipperIds: $shipperIds
        distributorIds: $distributorIds
        status: $status
        printStatus: $printStatus
        startDate: $startDate
        endDate: $endDate
        ngayDatHangStartDate: $ngayDatHangStartDate
        ngayDatHangEndDate: $ngayDatHangEndDate
        filter: $filter
        heThongMT: $heThongMT
        createdStartDate: $createdStartDate
        createdEndDate: $createdEndDate
        creatorFilter: $creatorFilter
      ) {
        total
        data {
          id
          poSaleOrderId
          shipperId
          status
          nguoiNhanHang
          ngayGiaoHang
          lyDoKhongPhatDuoc
          ngayDVVCLayHang
          tienCOD
          trongLuongTinhCuocKg
          soKien
          phiShip
          phiHoanTra
          noiDungKhac
          dain
          createdAt
          modifiedAt
          creator {
            id
            name
          }
          modifiedBy {
            id
            name
          }
          poSaleOrder {
            id
            cd
            orderDate
            deliveryAddress
            receiver
            customer {
              id
              cd
              name
              address1
              phone11
            }
            distributor {
              id
              cd
              name
            }
          }
          shipper {
            id
            cd
            name
          }
          items {
            id
            productId
            unitId
            soLuongGuiGiao
            soLuongGiaoThanhCong
            isFree
            donGia
            thanhTienTruocCK
            chietKhau
            thanhTien
            product {
              id
              cd
              name
              barcode
              otherReference
              salesUnit {
                id
                cd
              }
            }
            unit {
              id
              cd
            }
          }
        }
      }
    }
  }
`;

export interface PoSaleOrderShipmentListQueryVariables {
  page: number;
  pageSize: number;
  poSaleOrderId?: number;
  shipperId?: number;
  shipperIds?: number[];
  distributorIds?: number[];
  status?: string;
  printStatus?: string;
  startDate?: string;
  endDate?: string;
  ngayDatHangStartDate?: string;
  ngayDatHangEndDate?: string;
  filter?: string;
  heThongMT?: string[];
  createdStartDate?: string;
  createdEndDate?: string;
  creatorFilter?: string;
}

export const usePoSaleOrderShipmentListQuery = (options?: any) =>
  useQuery(PO_SALE_ORDER_SHIPMENT_LIST_QUERY, options);

